export const LeadsDataConstant = {

    
LEADS_DATA_SAGA: "LEADS_DATA_SAGA",
LEADS_DATA_REQUEST: "LEADS_DATA_REQUEST",
LEADS_DATA_RESPONSE: "LEADS_DATA_RESPONSE",
LEADS_DATA_API: "/landing-page-enquiry-list",


};